"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clean = clean;
exports.default = void 0;
exports.dispatch = dispatch;
exports.eventName = void 0;
exports.listen = listen;
exports.openSubscriptionWizard = void 0;
const eventName = exports.eventName = 'open-subscription-wizard';
const openSubscriptionWizard = exports.openSubscriptionWizard = eventName;
/**
 * Dispatch event which opens subscription or autoship wizard
 *
 * @param {CustomEventInit<EventData>} data data which will be passed to event
 * @fires globalThis#open-subscription-wizard:open-subscription-wizard
 */
function dispatch(data) {
  const event = new CustomEvent(eventName, data);
  globalThis.dispatchEvent(event);
}

/**
 * Listen callback for our event
 *
 * @callback listenCallback
 * @param {CustomEvent<EventData>} event - Event data
 * @returns {void}
 */

/**
 * Helper function which wraps event so we never miss.
 * @param {listenCallback} callback - That handles response
 * @param {(boolean | AddEventListenerOptions)} [options] - options of event
 */
function listen(callback, options) {
  globalThis.addEventListener(eventName, callback, options);
}

/**
 * Clean event when you don't need to listen anymore.
 * @param {listenCallback} callback - that should be cleaned.
 */
function clean(callback) {
  globalThis.removeEventListener(eventName, callback);
}
var _default = exports.default = {
  dispatch,
  listen,
  clean,
  eventName,
  openSubscriptionWizard
};
